export default {"src":"/_next/static/media/profile-weakness.03abd1b6.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};